module.exports = __webpack_public_path__ + "media/images/talent/lp/step02-933241321548d7da92be40c52577ee31.png";